import { render } from "./mallOrderManage.vue?vue&type=template&id=7f38dbd6"
import script from "./mallOrderManage.vue?vue&type=script&lang=js"
export * from "./mallOrderManage.vue?vue&type=script&lang=js"

import "./mallOrderManage.vue?vue&type=style&index=0&id=7f38dbd6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__